"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKeyOf = void 0;
function isKeyOf(object, potentialKey) {
    return typeof object === 'object' && potentialKey in object;
}
exports.isKeyOf = isKeyOf;
